// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1Fx9g","title":"ClientCherryInfo_title__32JLE","itemText":"ClientCherryInfo_itemText__1zpFV"};